import { ToastService } from '../services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ApiException, Request2FARegistrationCodeDTO, Request2FARegistrationCodeResponseDTO, RequestSelfReset2FARegistrationDTO, UserAccountClient, Verify2FARegistrationCodeDTO, Verify2FARegistrationCodeResponseDTO } from '../models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorAuthenticationRegistrationService {

  constructor(private userAccountClient: UserAccountClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService
  ) { }

  public requestCode(dto: Request2FARegistrationCodeDTO): Observable<Request2FARegistrationCodeResponseDTO> {
    this.spinnerService.show();
    return this.userAccountClient.request2FARegistrationCode(dto).pipe(tap({
      next: () => {
        this.spinnerService.hide();
      },
      error: (err: ApiException) => {
        this.spinnerService.hide();
        this.toastService.showApiExeption(err);
      }
    }),
    catchError((error) => {
      this.spinnerService.hide();
      throw error;
    }));
  }

  public verifyRegistration(dto: Verify2FARegistrationCodeDTO): Observable<Verify2FARegistrationCodeResponseDTO> {
    this.spinnerService.show();
    return this.userAccountClient.verify2FARegistrationCode(dto).pipe(tap({
      next: () => {
        this.spinnerService.hide();
        this.toastService.showSuccess('i18n.base.two-factor-authentication.registration.messages.registration-success.title', 'i18n.base.two-factor-authentication.registration.messages.registration-success.message');
      },
      error: () => {
        this.spinnerService.hide();
        this.toastService.showError('i18n.base.two-factor-authentication.registration.messages.registration-failure.title', 'i18n.base.two-factor-authentication.registration.messages.registration-failure.message');
      }
    }),
    catchError((error) => {
      this.spinnerService.hide();
      throw error;
    }));
  }

  public requestRecovery(dto: RequestSelfReset2FARegistrationDTO): Observable<void> {
    this.spinnerService.show();
    return this.userAccountClient.requestSelfReset2FARegistration(dto).pipe(tap({
      next: () => {
        this.spinnerService.hide();
      },
      error: (error: ApiException) => {
        this.spinnerService.hide();
        this.toastService.showApiExeption(error, 'i18n.base.two-factor-authentication.recovery.messages.recovery-failure.title', 'i18n.base.two-factor-authentication.recovery.messages.recovery-failure.message');
      }
    }),
    catchError((error) => {
      this.spinnerService.hide();
      throw error;
    }));
  }
}
